<template>
  <div class="dashboard-container w-100">
    <h3>Аналитика по исполнителям</h3>
    <div id="superset-container" ref="dashboardContainer"></div>
  </div>
</template>

<script>
import analytics from "../../network/analytics";

export default {
  name: "WorkersAnalytics",
  mixins: [
    analytics
  ],
  async created() {

  },
  mounted() {
    this.initSupersetDashboard();
  },
  methods: {
    // Метод, который SDK будет вызывать для получения/обновления токена
    async fetchGuestToken() {
      try {
        //const dashboardUuid = "fbd7c12e-42b3-4e77-b1ef-4a124b865138";
        const dashboardUuid = "db5e745c-b6d1-4d39-ade2-0e0f77f988e7";
        const response = await this.getSupersetToken(dashboardUuid);
        if (!response.data) {
          throw Error("Ошибка при получении Guest Token")
        }

        return response.data.guestToken;
      } catch (error) {
        //console.error('Ошибка при получении Guest Token:', error);
        throw error;
      }
    },
    initSupersetDashboard() {
      if (typeof window.supersetEmbeddedSdk === 'undefined') {
        //console.warn('Superset SDK еще не загрузился из CDN. Повторная попытка через 50мс...');

        // Перезапускаем этот же метод через 50 миллисекунд
        setTimeout(() => {
          this.initSupersetDashboard();
        }, 50);
        return;
      }

      //const dashboardUuid = "fbd7c12e-42b3-4e77-b1ef-4a124b865138";
      const dashboardUuid = "db5e745c-b6d1-4d39-ade2-0e0f77f988e7";

      //const supersetDomain = "http://localhost:8088"
      const supersetDomain = "https://merares.ruka-wfm.ru:8088"

      window.supersetEmbeddedSdk.embedDashboard({
        id: dashboardUuid, // Замените на UUID вашего дашборда из Superset
        supersetDomain: supersetDomain, // URL вашего Superset
        mountPoint: this.$refs.dashboardContainer, // Ссылка на DOM-элемент через refs
        fetchGuestToken: this.fetchGuestToken,    // Передаем метод как коллбэк
        dashboardUiConfig: {
          hideTitle: true,         // Скрыть стандартное название дашборда
          hideTab: true,          // Показывать вкладки дашборда
          hideChartControls: false,  // Скрыть контекстное меню графиков
          show_download: true,
        },
        iframeSandbox: [
          //'allow-same-origin', // Критически важно, чтобы убрать источник "null"
          //'allow-scripts',     // Разрешает работу JS внутри iframe
          //'allow-forms',       // Разрешает работу фильтров и форм
          //'allow-popups'       // Разрешает контекстные меню
        ]
      });
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

#superset-container {
  width: 100%;
  height: calc(100vh - 150px); /* Растягивает на всю высоту экрана минус 150px под шапку сайта */
  min-height: 600px;           /* Задаем минимальную высоту, чтобы графики не сжимались */
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  background: #f5f5f5;
  overflow: hidden;
}
/* Стилизация iframe, который создаст SDK */
#superset-container :deep(iframe) {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

#superset-container >>> iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Analytics/WorkersAnalytics.vue